// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZYLY","textarea":"styles_textarea__OvL4H"};